export const MAKE_A_MOVE = "MAKE_A_MOVE";
export const SET_SUCCESS_VALUE = "SET_SUCCESS_VALUE";
export const EXTEND_FIELD = "EXTEND_FIELD";